import { executeRequest, JFSRequest } from '@jfs/network'
import { formatDate, isSuccessResponse, removeEmpty } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return {
    ...data,
    content: data?.content?.map((item: any) => ({
      ID: item?.id,
      name: item?.name,
      type: item?.type,
      subType: item?.subType,
      status: item?.status,
      metadata: item?.metadata ?? 'NA',
      createdAt: formatDate(item?.createdAt),
      createdBy: item?.createdBy ?? 'NA',
      createdFrom: item?.createdFrom ?? 'NA',
      updatedAt: formatDate(item?.updatedAt),
      updatedBy: item?.updatedBy ?? 'NA',
      updatedFrom: item?.updatedFrom ?? 'NA',
      id: item?.id,
    })),
  }
}

const getAllEntityMaster = (requestBody: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.entityMasterGetAll),
    method: 'POST',
    cache: false,
    body: requestBody,
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export const getAllEntityMasterRequest = (data: any, paginationInfo: any) => {
  data = removeEmpty(data)
  console.log('data', data)
  return {
    inputFilter: data,
    configParams: paginationInfo,
  }
}

/*Long id;
String name;
EntityType type;
Boolean status;
SupportNetBanking supportNetBanking;
String ;*/

export { getAllEntityMaster }
